import React from 'react';
import styles from './TableContent.module.scss';
import { Table } from 'antd';
import PropTypes from 'prop-types';
import { tooltipStyle, tooltip, cellWidth } from '@/components/TableCell';

class AdvertTable extends React.Component {

    _takeColumns = () => {

        let cols = [
            {
                title: '菜单名称',
                dataIndex: 'menuName',
                key: 'menuName',
                width: '15%',
                align: 'left',
                onCell: tooltipStyle,
                render: tooltip
            },
            {
                title: '菜单ID',
                dataIndex: 'id',
                key: 'id',
                width: '10%',
                align: 'center',
                onCell: tooltipStyle,
                render: tooltip
            },
            {
                title: '菜单目录',
                dataIndex: 'menuTypeValue',
                key: 'menuTypeValue',
                width: '10%',
                align: 'center',
                onCell: tooltipStyle,
                render: tooltip
            },
            {
                title: 'URL',
                dataIndex: 'menuUrl',
                key: 'menuUrl',
                width: '15%',
                align: 'center',
                onCell: tooltipStyle,
                render: tooltip
            },
            {
                title: '状态',
                dataIndex: 'statusValue',
                key: 'statusValue',
                width: '5%',
                align: 'center',
                onCell: tooltipStyle,
                render: tooltip
            },
            {
                title: '操作人',
                dataIndex: 'modifyUserName',
                key: 'modifyUserName',
                width: '10%',
                align: 'center',
                onCell: tooltipStyle,
                render: tooltip
            },
            {
                title: '创建时间',
                dataIndex: 'gmtCreate',
                key: 'gmtCreate',
                width: '15%',
                align: 'center',
                onCell: tooltipStyle,
                render: tooltip
            },
            {
                title: '操作',
                dataIndex: 'id',
                key: 'id',
                align: 'center',
                width: '20%',
                render: (text, item) => this._renderActionCell(item)
            }
        ];
        return cols;
    };

    _takeDataSource = (dataList) => {
        if (dataList) {
            return dataList;
        } else {
            return [];
        }
    }

    _renderActionCell = (item) => {
        const { tableAction } = this.props;
        return (
            <div className={styles.action}>
                <div className={styles.item} onClick={() => tableAction('edit', item)}>编辑</div>
                {item.status === 1 && <div className={styles.item} onClick={() => tableAction('forbid', item)}>禁用</div>}
                {item.status === 0 && <div className={styles.item} onClick={() => tableAction('start', item)}>启用</div>}
                <div className={styles.item} onClick={() => tableAction('del', item)}>删除</div>
            </div>
        );
    }

    render() {
        const { renderData } = this.props;

        return (
            <div className={styles.tableContainer}>
                <Table
                    rowClassName={(record, index) => index % 2 === 0 ? '' : styles.tdcolor}
                    rowKey={(record) => record.id}
                    columns={this._takeColumns()}
                    dataSource={this._takeDataSource(renderData)}
                    pagination={false}
                    scroll={{ y: true }}
                />
            </div>
        );
    }
}

AdvertTable.propTypes = {
    renderData: PropTypes.array, // 表格数据源
    tableAction: PropTypes.func.isRequired, // 表格操作
    curTabID: PropTypes.string, // 当前tab类型
};

export default AdvertTable;